.slide-backdrop {
  container: backdrop / size;
  overflow: hidden;
  position: relative;
  background: #cbcbca;
  
  &.preview {
    aspect-ratio: 16/9;
    border: 1px solid #000;
  }
  &.full {
    width: 100%;
    height: 100dvh;
  }

  .slide-viewport {
    position: absolute;
    inset: 0;
    container: backdrop / size;
  }

  .slide-container {
    container: slide /size;
    position: relative;
    box-shadow: 0px 0px 10px rgba(0,0,0, 0.5);

    height: 100cqh;
    width: calc(16/9 * 100cqh);
    margin: 0 auto;

    @container backdrop (max-aspect-ratio: 16/9) {
      width: 100cqw;
      height: calc(9/16 * 100cqw);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    @container backdrop (min-aspect-ratio: 16/9) {
    }
  }
}
